import analyticsReducer from './reducers';

export { default as analyticsActions } from './actions';

export default analyticsReducer;
